const VideoConferencing = () => {
    return (

        <div className='px-7'>VideoConferencing</div>

    )
}

export default VideoConferencing;